// Apex Images
import GreenImage from '../../images/team-icons/S2_ActiveTeam_Green.png';
import BlueImage from '../../images/team-icons/S2_ActiveTeam_Blue.png';
import YellowImage from '../../images/team-icons/S2_ActiveTeam_Yellow.png';
import PurpleImage from '../../images/team-icons/S2_ActiveTeam_Purple.png';
import BlackImage from '../../images/team-icons/S2_ActiveTeam_Black.png';
import RedImage from '../../images/team-icons/S2_ActiveTeam_Red.png';

// Starforce Images
import SfGreenImage from '../../images/team-icons/SF_mascot-green-sq-selected.png';
import SfBlueImage from '../../images/team-icons/SF_mascot-blue-sq-selected.png';
import SfYellowImage from '../../images/team-icons/SF_mascot-yellow-sq-selected.png';
import SfPurpleImage from '../../images/team-icons/SF_mascot-purple-sq-selected.png';
import SfBlackImage from '../../images/team-icons/SF_mascot-black-sq-selected.png';
import SfRedImage from '../../images/team-icons/SF_mascot-red-sq-selected.png';

export default ({
  teamSelectorType,
  teamColor = '',
  setTeamColor,
  peformAutoNextAction,
}) => {

  const isStarforce = teamSelectorType === 'starforce'

  const colorImageMap = isStarforce ? {
    Green: SfGreenImage,
    Blue: SfBlueImage,
    Yellow: SfYellowImage,
    Purple: SfPurpleImage,
    Black: SfBlackImage,
    Red: SfRedImage
  } : {
    Green: GreenImage,
    Blue: BlueImage,
    Yellow: YellowImage,
    Purple: PurpleImage,
    Black: BlackImage,
    Red: RedImage
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'auto'
    }}>
      <div style={{
        color: '#ffffff',
        fontWeight: 'bold',
        fontSize: '48px'
      }}>
        {'Select Your Team!'}
      </div>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: '10px',
        columnGap: '10px',
        justifyContent: 'center',
        margin: '40px 0px'
      }}>
        {
          Object.keys(colorImageMap).map(color => {
            const colorImage = colorImageMap[color];
            return (
              <div 
                key={color}
                onClick={() => {
                  setTeamColor(color)
                  peformAutoNextAction()
                }}
                style={{
                  cursor: 'pointer',
                  border: teamColor === color ? '6px solid #b16179' : '6px solid transparent',
                  background: teamColor === color ? '#d2275a' : 'transparent',
                  borderRadius: isStarforce ? '40px' : '50%',
                  padding: isStarforce ? '5px 2px 0px 2px' : '10px 2px 0px 2px'
                }}
              >
                <img src={colorImage} style={{ height: '200px' }} alt={`team-color-${color}`} />
              </div>
            )
          })
        }
      </div>
    </div>
  )
}